/* Recover empty resource pickers from the selected resource's own Liquid context. */
(() => {
  const requests = new Map();
  function readCards(url) {
    if (!requests.has(url)) {
      requests.set(url, (async () => {
        const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`Storefront response ${response.status}`);
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = [...page.querySelectorAll('[data-catalog-recovery] > .product-card')];
        if (!cards.length) throw new Error('The resource page returned no product cards');
        return cards;
      })());
      requests.get(url).catch(() => requests.delete(url));
    }
    return requests.get(url);
  }
  async function recover(host) {
    if (host.dataset.recoveryState || !host.dataset.resourceHandle) return;
    host.dataset.recoveryState = 'loading';
    host.setAttribute('aria-busy', 'true');
    try {
      const root = host.dataset.root || '/';
      const path = host.dataset.resourceKind === 'collection' ? 'collections/' : 'products/';
      const url = new URL(root + path + encodeURIComponent(host.dataset.resourceHandle), location.origin);
      url.searchParams.set('section_id', 'catalog-recovery');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const cards = await readCards(url.href);
      if (!host.isConnected) return;
      const limit = Math.max(1, Math.min(250, Number(host.dataset.limit) || 1));
      const fragments = cards.slice(0, limit).map(card => {
        const copy = card.cloneNode(true);
        const media = copy.querySelector('.product-card__media');
        if (media && host.dataset.cardStyle) media.setAttribute('style', host.dataset.cardStyle);
        return copy;
      });
      host.replaceChildren(...fragments);
      host.dataset.recoveryState = 'loaded';
    } catch (error) {
      host.dataset.recoveryState = 'failed';
      const message = host.querySelector('[data-recovery-message]');
      if (message) message.textContent = 'The storefront did not return this selection. Its saved handle is ' + host.dataset.resourceHandle + '. ' + error.message + '.';
      // Keep the direct resource link available if a request fails; never invent inventory.
      host.querySelector('[data-recovery-retry]')?.removeAttribute('hidden');
    } finally {
      host.removeAttribute('aria-busy');
    }
  }
  function init(scope) {
    scope.querySelectorAll('[data-catalog-pending]').forEach(recover);
  }
  document.addEventListener('click', event => {
    const retry = event.target.closest('[data-recovery-retry]');
    if (!retry) return;
    const host = retry.closest('[data-catalog-pending]');
    retry.hidden = true;
    delete host.dataset.recoveryState;
    recover(host);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
